import { createItem, deleteItem, readItems, updateItem } from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";
const directus = getDirectusClient();

export const getImpuestos = async () => {
  try {
    const response = await directus.request(
      readItems("impuestos", {
        fields: ["id", "nombre", "porcentaje"],
      })
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const updateImpuesto = async (id, data) => {
  try {
    const response = await directus.request(updateItem("impuestos", id, data));
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const getImpuestoByGrupo = async (id) => {
  try {
    const response = await directus.request(
      readItems("impuestos", {
        fields: ["id", "nombre", "porcentaje", "gropo.*"],
        filter: {
          gropo: { grupos_id: { id: { _eq: id } } },
        },
      })
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getImpuestosByGrupo = async (id) => {
  try {
    const response = await directus.request(
      readItems("impuestos", {
        fields: ["porcentaje", "nombre", "gropo"],
        filter: {
          gropo: {
            grupos_id: { id: { _eq: id } },
          },
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const deleteImpuesto = async (id) => {
  try {
    const response = await directus.request(deleteItem("impuestos", id));
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createImpuesto = async (data) => {
  try {
    const response = await directus.request(createItem("impuestos", data));
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


